import { alpha, makeStyles } from '@mui/styles';

export const useAppBarOutletContent = makeStyles({
    root: {
        boxShadow: "none"
    }
});